import { useEffect, useState } from 'react';
import companySettings from '@/services/setting/companySettings';

/**
 * Fetches this node's company logo (single-tenant) for pre-auth pages so the
 * login / reset-password / public-header screens render the same uploaded logo
 * the authenticated dashboard shows.
 *
 * Returns the logo URL, or null while loading or when none is set — callers
 * fall back to the placeholder logo.
 */
const useCompanyLogo = () => {
  const [companyLogo, setCompanyLogo] = useState(null);

  useEffect(() => {
    let active = true;

    companySettings
      .getPublicCompanyLogo()
      .then((data) => {
        if (active && data?.company_logo) {
          setCompanyLogo(data.company_logo);
        }
      })
      .catch(() => {
        // Ignore — the caller falls back to the placeholder logo.
      });

    return () => {
      active = false;
    };
  }, []);

  return companyLogo;
};

export { useCompanyLogo };
